import React from 'react';
import '../../styles/TransferRequestForm.css';

function TransferRequestForm() {
  return (
    <div className="transfer-request-form">
      <h2>TRANSFER REQUEST FORM</h2>
      <div className="form-group">
        <label htmlFor="fromGroup">From</label>
        <select id="fromGroup">
          <option>Which group is transferring?</option>
          {/* Add options here */}
        </select>
      </div>
      <div className="form-group">
        <label htmlFor="toGroup">To</label>
        <select id="toGroup">
          <option>Which group is receiving a new member?</option>
          {/* Add options here */}
        </select>
      </div>
      <div className="form-group">
        <label htmlFor="member">Member Name</label>
        <select id="member">
          <option>Select the member being transferred</option>
          {/* Add options here */}
        </select>
      </div>
      <div className="form-group">
        <label htmlFor="date">Date</label>
        <input type="date" id="date" placeholder="Date on which the transfer was made" />
      </div>
      <div className="form-group">
        <label htmlFor="agreement">Agreement</label>
        <input type="file" id="agreement" />
        <p className="file-description">Attach an agreement signed by other members</p>
      </div>
      <button type="submit">Submit Transfer Request</button>
    </div>
  );
}

export default TransferRequestForm;